import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { Redirect } from "react-router-dom";
// Utils
import { GET_STOCK_MEDICINE_ITEM } from "api/Medicine/queries";
import { getBUFromLocalStorage } from "helpers/storage";
import { MEDICINE_CABINET } from "constants/Routes";
import { useEventRequest } from "hooks";
// Components
import { MedicineInfoBlock } from "medicines/components/MedicineInfoBlock";
import { MedicineTabsBlock } from "medicines/components/MedicineTabsBlock";
import { Breadcrumbs, LoadingOverlay, Header, PageHeader, PageContent, Spacer } from "components";

export const MedicineDetails: React.FC = () => {
  const { id } = useParams<MedicinePageParams>();
  const { eventsRequest } = useEventRequest();
  const { data, error, loading } = useQuery(GET_STOCK_MEDICINE_ITEM, {
    variables: {
      id,
      businessUnitId: getBUFromLocalStorage(),
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  useEffect(() => {
    if (data) {
      eventsRequest({ name: "med-cab-view-med-details", details: { stockItemId: data.stockItem.id } });
    }
  }, [data]);

  if (error) {
    return <Redirect to={MEDICINE_CABINET} />;
  }

  return loading ? (
    <LoadingOverlay />
  ) : (
    <>
      <PageHeader>
        <Breadcrumbs
          rootPaths={[
            {
              path: "Medicine Cabinet",
              route: MEDICINE_CABINET,
            },
          ]}
          currentPath="Medicine details"
        />
        <Header backButton title={data?.stockItem?.name} />
        <MedicineInfoBlock medicine={data?.stockItem} />
        <Spacer baselineHeight={1} />
      </PageHeader>
      {data?.stockItem?.lineItems.length > 0 && (
        <PageContent>
          <Spacer baselineHeight={3} />
          <MedicineTabsBlock lineItems={data?.stockItem?.lineItems} />
          <Spacer baselineHeight={2} />
        </PageContent>
      )}
    </>
  );
};
